module.exports = __webpack_public_path__ + "img/forum.4de78e1e.svg";